import { render, staticRenderFns } from "./OracleConfigurationList.vue?vue&type=template&id=2222d8b4"
import script from "./OracleConfigurationList.vue?vue&type=script&lang=js"
export * from "./OracleConfigurationList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports